export const environment = {
    production: true,
    apiURL: 'https://green.multipedidos.com.br',
    imgURL: 'https://images.multipedidos.com.br',
    orderCacheURL: 'https://product-suggestion.lambda.multipedidos.com.br',
    onesignalAppID: "81ee0c26-fc4e-4d22-90f6-5fd176a67fda",
    pusher: {
      key: '715a9e0b34b517fdbc67',
      cluster: 'us3',
      forceTLS: true
    },
    googleMapsKey: 'AIzaSyCaspbeWCXZIbIBNfrP621V_cO6EXVqTd0',
    orderCacheURLTracking: 'https://qfp25t5ymcx5hho2umb553dmh40jeony.lambda-url.us-east-1.on.aws',
    // Instância self-hosted do OpenPanel (funil de conversão v2).
    openPanel: {
      apiUrl: 'https://events.pedir.delivery',
      clientId: '690f3f9b-22b9-4395-892d-464d8979dc1b',
    },
    // Telemetria do funil do pedido (stack SAM order-flow-monitor).
    // Vazio = nao emite. Este ambiente nao alimenta o funil de producao.
    orderFlowLogURL: '',
    mpBannerLogURL: '',
    // Nova tela de enderecos (stack SAM aws-sam-telemetria-nova-tela-enderecos).
    // Vazio = nao emite. Este ambiente nao alimenta a stack de producao.
    multiSignalLogURL: '',
    // Sentry — ver SENTRY.md. Ambiente de validação: tráfego baixo e conhecido,
    // então captura TUDO (100% dos devices, replay de toda sessão com erro). É
    // aqui que se prova a config antes de subir o degrau em produção — e para
    // provar o Replay é preciso que ele grave na primeira tentativa.
    //
    // A quota é COMPARTILHADA com produção (é da organização): se o green algum
    // dia receber tráfego real, estes 100% viram um vazamento de quota. Hoje
    // não recebe.
    sentry: {
      dsn: 'https://7fcf9b05d3b8abe063fb2a5404a231f4@o1392158.ingest.us.sentry.io/4508269894238208',
      environment: 'green',
      clientSamplePct: 100,
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 1.0,
    },
    // Página de design system (/design-system): ferramenta local de desenvolvimento,
    // nunca publicada fora do `ionic serve`.
    designSystemPage: false,
};
  
